import { createAction, props } from '@ngrx/store';
import { Pagination } from '../models/pagination.model';
import { Profile } from '../models/profile.model';

export const setProfiles = createAction('[Profiles Component] SetProfiles', props<Pagination<Profile>>());
